import { Heading } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import {
  BaseComponent,
  SbBlokData,
  StoryblokImage,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import './landing-hero.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import Image from 'next/image'
import { StoryblokRenderer } from '../../../storyblok-renderer/storyblok-renderer'
import { storyblokComponents } from '../../../storyblok/storyblok-renderer-map'
import styles from './landing-hero.module.css'

export interface LandingHeroProps extends BaseComponent {
  logo: StoryblokImage
  heading: string
  ctaButton: SbBlokData
  image: StoryblokImage
}

interface HeroContentProps {
  logo: StoryblokImage
  heading: string
  ctaButton: SbBlokData
}

const HeroContent: React.FC<HeroContentProps> = ({
  logo,
  heading,
  ctaButton,
}) => (
  <div className={styles.brandContent}>
    <div className={styles.logoWrapper}>
      <Image
        src={logo.filename}
        alt={logo?.alt ?? 'heroLogo'}
        priority
        quality={100}
        layout="fill"
        objectFit="fill"
      />
    </div>
    <Heading element="h1" className={styles.heading}>
      {heading}
    </Heading>
    <StoryblokRenderer block={ctaButton} components={storyblokComponents} />
  </div>
)

const DesktopHero: React.FC<LandingHeroProps> = ({
  logo,
  heading,
  ctaButton,
  image,
}) => (
  <div className={styles.heroWrapper}>
    <HeroContent logo={logo} heading={heading} ctaButton={ctaButton} />
    <div className={styles.imageWrapper}>
      <Image
        src={image.filename}
        alt={image.alt ?? 'heroImage'}
        className={styles.image}
        quality={100}
        priority
        fill={true}
        style={{
          objectFit: 'contain',
          objectPosition: 'center',
        }}
      />
    </div>
  </div>
)

const MobileHero: React.FC<LandingHeroProps> = ({
  logo,
  heading,
  ctaButton,
  image,
}: LandingHeroProps) => (
  <>
    <HeroContent logo={logo} heading={heading} ctaButton={ctaButton} />
    <div className={styles.imageWrapper}>
      <Image
        src={image.filename}
        alt={image.alt ?? 'heroImage'}
        className={styles.image}
        priority
        quality={100}
        layout="fill"
        objectFit="contain"
      />
    </div>
  </>
)

export const LandingHero: React.FC<LandingHeroProps> = (blok) => {
  const { vw } = useViewport()
  const isMobile = vw < 1024

  return (
    <Wrapper
      {...storyblokEditable(blok)}
      isFluid
      className={{
        inner: styles.container,
      }}
    >
      {isMobile ? <MobileHero {...blok} /> : <DesktopHero {...blok} />}
    </Wrapper>
  )
}
